/* eslint-disable import/prefer-default-export */
export const MAX_ITEMS_PER_PAGE = 20;
